export default "__VITE_ASSET__b1b6f181__"